import { create } from 'zustand';

/**
 * Channel that originated the current create-experiment flow, captured on
 * the `/experiments/create` channel picker so the onboarding integration
 * flow knows to redirect the user back to `/experiments/create/info` once
 * the prerequisite connectors are all in place.
 */
export type ExperimentCreateOriginChannel = 'google';

interface ExperimentCreateOriginState {
  originChannel: ExperimentCreateOriginChannel | null;
  setOriginChannel: (channel: ExperimentCreateOriginChannel) => void;
  clearOriginChannel: () => void;
}

/**
 * In-memory (not persisted) — the cross-flow redirect only needs to survive
 * an SPA navigation, not a reload. A stale flag after reload would silently
 * hijack plain onboarding, so we intentionally let it reset.
 */
export const useExperimentCreateOriginStore = create<ExperimentCreateOriginState>((set) => ({
  originChannel: null,
  setOriginChannel: (channel) => {
    set({ originChannel: channel });
  },
  clearOriginChannel: () => {
    set({ originChannel: null });
  },
}));
